import React from 'react';

import AreaList from '../area/AreaList';
import Col from 'react-bootstrap/Col';
import EditorSaveCancel from '../shared/buttons/EditorSaveCancel';
import Form from 'react-bootstrap/Form';
import FormControl from '../shared/inputs/FormControl';
import GlobalValidationLabel from '../shared/inputs/GlobalValidationLabel';
import Row from 'react-bootstrap/Row';
import SelectList from '../shared/inputs/SelectList';
import permissionsProvider from '../../utilities/permissionsProvider';
import ActionButton from '../shared/buttons/ActionButton';
import postData from '../../utilities/postData';

const EditForm = ({
    cancelEdit,
    form: { formChange },
    form: { item },
    proposalId,
    submitForm
}) => {

    const disabled = !permissionsProvider.canEdit(item.acl);
    const pdfUrl = `/reports/proposalPdf/${item.id}`;

    return (
        <div>
            <div className="item-editor">
                <Row className="justify-content-between">
                    <Col xs="auto">
                        <a href={`/proposals/getpdf/${item.id}`} target="_blank">
                        <ActionButton
                            buttonText="Print"
                            imgSource="/images/eye.svg"
                            disabled={item.id === 0}
                            />
                            </a>
                    </Col>
                    <Col xs="auto" className="fields-required-label" />
                </Row>
                <Row>
                    <Form.Group as={Col} xs={6}>
                        <Form.Row>
                            <Form.Label as={Col} xs="auto">
                                Number
                            </Form.Label>
                            <Col>
                                <FormControl
                                    type="number"
                                    defaultValue={Number.isNaN(item.proposalNumber) ? '' : item.proposalNumber}
                                    name="proposalNumber"
                                    onChange={formChange}
                                    placeholder="Proposal Number"
                                    required
                                    validationError={item.proposalNumber_error}
                                    disabled={disabled} />
                            </Col>
                        </Form.Row>
                    </Form.Group>
                    <Form.Group as={Col} xs={6}>
                        <SelectList
                            onChange={formChange}
                            lookupType="Designer"
                            name="designerId"
                            placeholder="Designer"
                            required={true}
                            value={item.designerId}
                            validationError={item.designerId_error}
                            disabled={disabled} />
                    </Form.Group>
                </Row>
                <Row>
                    <Form.Group as={Col} className="py-2 px-3">
                        <GlobalValidationLabel validationError={item.areas_error} />
                        <AreaList
                            formChange={formChange}
                            items={item.areas}
                            proposalId={proposalId}
                            disabled={disabled} />
                    </Form.Group>
                </Row>
                <Row>
                    <Col>
                        <FormControl as="textarea"
                            className="form-control"
                            defaultValue={item.note}
                            validationError={item.note_error}
                            name="note"
                            onChange={formChange}
                            rows="6"
                            placeholder="Notes"
                            disabled={disabled} />
                    </Col>
                </Row>
            </div>
            <EditorSaveCancel
                save={submitForm}
                cancel={cancelEdit}
                acl={item.acl} />
        </div>
    );
}

export default EditForm;